import eventListenerOption from "../lib/eventListenerOption";

export default function init() {
	const sections = document.querySelectorAll('.productArchiveResults__section');
	if (sections.length === 0) {
		return;
	}

	const sectionsContainer = sections[0].parentElement;
	const sectionsArray = Array.from(sectionsContainer.children);
	const localNav = document.querySelector('.localNav');

	// Test which section is tallest
	// Derived from https://bitbucket.org/plaudit/avionte-local-version/src/master/wp-content/themes/avionte-2017/plaudit/preprocess/component/HomepageAnimation.ts
	var intersectingElems = sections;

	function calculateVisibleHeightInViewport(elem:any) {
		const elemRect = elem.getBoundingClientRect();
		const vh = document.documentElement.clientHeight;
		if (elemRect.bottom < 0 || elemRect.top > vh) {
			return 0;
		}
		
		const bottom = Math.min(elemRect.bottom, vh);
		const top = Math.max(elemRect.top, 0);
		return bottom - top;
	}

	function checkVisibleElements() {
		let maxVisibleHeight = 0;
		let maxVisibleHeightElement = null;
		let indexOfMaxVisibleHeightElement = null;

		for (let i = 0; i < intersectingElems.length; i++) {
			let visibleHeight = calculateVisibleHeightInViewport(intersectingElems[i]);

			if (visibleHeight > maxVisibleHeight) {
				maxVisibleHeight = visibleHeight;
				maxVisibleHeightElement = intersectingElems[i];
			}
		}

		for (let i = 0; i < intersectingElems.length; i++) {
			if (maxVisibleHeightElement != intersectingElems[i]) {
				localNav.querySelector(`li:nth-child(${i + 1})`).classList.remove('active');
				//intersectingElems[i].classList.remove('start-animation');
			}
		}

		if (maxVisibleHeightElement != null) {
			indexOfMaxVisibleHeightElement = sectionsArray.indexOf(maxVisibleHeightElement);
			localNav.querySelector(`li:nth-child(${indexOfMaxVisibleHeightElement + 1})`).classList.add('active');
			//maxVisibleHeightElement.classList.add('start-animation');
		}
	}

	function updatePage() {
		checkVisibleElements();
	}
		
	updatePage();
	window.addEventListener('scroll', updatePage, eventListenerOption.passiveNotCapture);
	window.addEventListener('resize', updatePage);
	window.addEventListener('touchend', updatePage);
}
